"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargeSchema = void 0;
const zod_1 = require("zod");
const Echarge_1 = require("./Echarge");
const ChargeSchema = zod_1.z.object({
    name: zod_1.z.string(),
    amount: zod_1.z.number(),
    bonusMalusAmout: zod_1.z.number(),
    createdCharge: zod_1.z.boolean(),
    pleasurePointsMalus: zod_1.z.number(),
    huissier: zod_1.z.boolean(),
    isPaid: zod_1.z.boolean(),
    pleasurePointsToAdd: zod_1.z.number(),
    chargeEnum: zod_1.z.nativeEnum(Echarge_1.ECharge),
});
exports.ChargeSchema = ChargeSchema;
